import React from 'react';
import { Box, Flex, Heading, Text, Icon, VStack, useTheme } from '@chakra-ui/react';
import { AiOutlineDatabase, AiOutlineWarning } from 'react-icons/ai';
import DatabaseProgress from './DatabaseProgress'; // Importa o componente de progresso

const DatabaseUsageCard = ({ db }) => {
    const theme = useTheme(); 

    // Caso haja erro, mantém vermelho (não mexemos nisso)
    if (db.error) {
        return (
            <Box 
                bg="surface" 
                p={5} 
                borderRadius="lg" 
                border="1px solid" 
                borderColor="red.500" 
                h="100%" 
                minH="200px" 
                transition="all 0.2s ease-in-out" 
                boxShadow="md" 
            >
                <Flex align="center" mb={4}>
                    <Icon as={AiOutlineWarning} boxSize={8} color="red.400" mr={4} />
                    <Box>
                        <Heading as="h4" size="md" color="white" noOfLines={1}>{db.nome}</Heading>
                        <Text fontSize="sm" color="red.400">{db.error}</Text>
                    </Box>
                </Flex>
                <Text fontSize="xs" color="gray.500">Verifique as permissões ou se o banco está online.</Text>
            </Box>
        );
    }

    // Força tudo para verde padrão do tema
    const iconColor = theme.colors.secondary;

    const tamanhoTotalFormatted = db.tamanhoTotalMB !== undefined 
        ? `${db.tamanhoTotalMB.toLocaleString('pt-BR')} MB` 
        : null;

    const espacoUsadoFormatted = db.espacoUsadoMB !== undefined
        ? `${db.espacoUsadoMB.toLocaleString('pt-BR')} MB`
        : 'N/A';

    const espacoLivreFormatted = db.espacoLivreMB !== undefined
        ? `${db.espacoLivreMB.toLocaleString('pt-BR')} MB`
        : null;

    return (
        <Box 
            bg="surface" 
            p={5} 
            borderRadius="lg" 
            border="1px solid" 
            borderColor="gray.800" 
            h="100%" 
            minH="200px" 
            transition="all 0.2s ease-in-out" 
            boxShadow="md" 
            _hover={{ 
                borderColor: theme.colors.secondary,
                transform: 'translateY(-2px)',
                boxShadow: `0 4px 12px 0 rgba(2, 234, 117, 0.2)` 
            }}
        >
            <Flex align="center" mb={4}>
                <Icon as={AiOutlineDatabase} boxSize={8} color={iconColor} mr={4} />
                <Box minW={0}> 
                    <Heading as="h4" size="md" color={theme.colors.secondary} isTruncated title={db.nome}>
                        {db.nome}
                    </Heading>
                    {tamanhoTotalFormatted && (
                        <Text fontSize="sm" color="gray.400">Total: {tamanhoTotalFormatted}</Text>
                    )}
                    {!tamanhoTotalFormatted && (
                         <Text fontSize="sm" color="gray.400">Usado: {espacoUsadoFormatted}</Text>
                    )}
                </Box>
            </Flex>
            <VStack spacing={4} align="stretch" mt="auto"> 
                {tamanhoTotalFormatted && espacoLivreFormatted && (
                    <VStack spacing={1} align="stretch" fontSize="sm">
                        <Flex justify="space-between">
                            <Text color="gray.300">Usado:</Text>
                            <Text color={theme.colors.secondary} fontWeight="bold">{espacoUsadoFormatted}</Text>
                        </Flex>
                        <Flex justify="space-between">
                            <Text color="gray.300">Livre:</Text>
                            <Text color={theme.colors.secondary} fontWeight="bold">{espacoLivreFormatted}</Text>
                        </Flex>
                    </VStack>
                )}
                <DatabaseProgress 
                    value={db.porcentagemUsado} 
                    // força o verde também na barra de progresso
                    status="success" 
                />
            </VStack>
        </Box>
    );
};

export default DatabaseUsageCard;
